import { NBSP } from './symbols';

export const SERVICE_NAMES_DICT: TDict = {
  top3: ['Топ-объявление', 'Топ-объявления', 'Топ-объявлений'],
  premium: ['Премиум-объявление', 'Премиум-объявления', 'Премиум-объявлений'],
  'premium+highlight': ['Премиум-объявление', 'Премиум-объявления', 'Премиум-объявлений'],
  'paid+highlight': ['Платное объявление', 'Платных объявления', 'Платных объявлений'],
  paid: ['Платное объявление', 'Платных объявления', 'Платных объявлений'],
  free: ['Бесплатное объявление', 'Бесплатных объявления', 'Бесплатных объявлений'],
};

export const SERVICE_NAMES: TStringObject = {
  top3: 'Топ',
  'premium+highlight': `Премиум с${NBSP}выделением цветом`,
  premium: 'Премиум',
  'paid+highlight': `Платное с${NBSP}выделением цветом`,
  paid: 'Платное',
  free: 'Бесплатное',
};
